import { render, staticRenderFns } from "./MoveFile.vue?vue&type=template&id=166541d8&scoped=true"
import script from "./MoveFile.vue?vue&type=script&lang=js"
export * from "./MoveFile.vue?vue&type=script&lang=js"
import style0 from "./MoveFile.vue?vue&type=style&index=0&id=166541d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166541d8",
  null
  
)

export default component.exports